const PHONE_PREFIX = '+53';

module.exports = {
    PHONE_PREFIX,
    HTTP_ERRORS: {
        HTTP_418: 418,
        HTTP_422: 422,
    },
};



/** WEBPACK FOOTER **
 ** ./src/constants/index.js
 **/